

















import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Question,
    },
  },

  computed: {
    mandatoryOptions(): any {
      return [
        {
          text: this.$tc(`model.question.validation.mandatory.options.none`),
          value: 'none',
        },
        !this.notMandatory
          ? {
              text: this.$tc(
                `model.question.validation.mandatory.options.soft`
              ),
              value: 'soft',
            }
          : undefined,
        !this.notMandatory
          ? {
              text: this.$tc(
                `model.question.validation.mandatory.options.submit`
              ),
              value: 'submit',
            }
          : undefined,
      ].filter((option) => !!option);
    },

    notMandatory(): boolean {
      return (
        this.value?.questiontype?.key === 'table_format' ||
        this.value?.questiontype?.key === 'text_block'
      );
    },
  },

  mounted() {
    // mandatory: 'none' | 'soft' | 'submit';
    this.$emit('input', {
      validation: {
        mandatory: this.notMandatory
          ? 'none'
          : this.value.validation?.mandatory || 'none',
      },
    });
  },
});
